import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_VIEW from "./KAMPYLE_VIEW";
import KAMPYLE_EVENT_DISPATCHER from "./KAMPYLE_EVENT_DISPATCHER";

var partialViewSupportedTriggers = [KAMPYLE_CONSTANT.FORM_TYPES.INVITATION, KAMPYLE_CONSTANT.FORM_TYPES.CODE];
var isFullscreenScale, MAX_ALLOWED_SCALE = 1.5;
var isCurrentFullScreen = false;
var isMobileLandscape = false;

function init() {
    var eventMapping = {
        neb_beforeFormShown: [reactToHeightRatioChange],
        neb_formClosed: [restoreContainerPartialViewStyles, animateOut],
    };

    KAMPYLE_EVENT_DISPATCHER.subscribeMany(eventMapping);
    initListenToResize();
    isMobileLandscape = KAMPYLE_UTILS.isMobileLandscape();
}

function initListenToResize() {
    if (window.visualViewport) {
        isFullscreenScale = window.visualViewport.scale > MAX_ALLOWED_SCALE;
        var debouncedListenToResize = KAMPYLE_UTILS.debounce(listenToResize, 150, false);
        debouncedListenToResize();
    }
}


function updateRatioForAllDisplayedForms(isFullscreen) {
    var shownFormsState = KAMPYLE_DATA.getAllShownForms();
    for (var formId in shownFormsState) {
        if (shownFormsState[formId].ratio  && shownFormsState[formId].ratio < 1) {
            updateRatioForDisplayedForm(formId, isFullscreen);
        }
    }
}

function allowInteractionWithHost() {
    var containerEl = document.getElementById('kampyleFormContainer');
    if (!containerEl) {
        return;
    }
    KAMPYLE_UTILS.setElementStyle(containerEl, { 'pointer-events': 'none', 'background-color': 'transparent' }, true);
    KAMPYLE_VIEW.restoreHostingDOM();
    document.addEventListener('focusin', closePartialViewOnHostInput, true);
}

function setPartialViewStyles(formIframe, formId, partialViewRatio, isInitialSetup) {
    var formData =  KAMPYLE_DATA.getFormData(formId);
    var position = formData.inviteData && formData.inviteData.skipInvitation !== 'true' && formData.inviteData.invitationPosition || 'bottom';
    var partialStyle = {
        'pointer-events': 'auto',
        'box-shadow': '0px 0px 25px 0px #00000040',
        transition: 'all 1s ease-in-out',
        'border-radius': position === 'top' ? '0 0 8px 8px' : '8px 8px 0 0',
    };
    if (isInitialSetup) {
        partialStyle[position] = '-100%';
    }
    var style = getHeightStyle((Number(partialViewRatio) * 100) + 'vh');
    Object.assign(partialStyle, style);
    KAMPYLE_UTILS.setElementStyle(formIframe, partialStyle, true);
    animateIn(formIframe, position);
}

function handleFullscreenStateChange() {
    const isPrevFullscreen = isMobileLandscape || isFullscreenScale;
    const isOrientationChanged = isMobileLandscape !== KAMPYLE_UTILS.isMobileLandscape();
    if (isOrientationChanged) {
        isMobileLandscape = KAMPYLE_UTILS.isMobileLandscape();
    }
    const currentScale = window.visualViewport && window.visualViewport.scale;
    const isScaleChanged = isFullscreenScale !== (currentScale > MAX_ALLOWED_SCALE);
    if (isScaleChanged) {
        isFullscreenScale = currentScale > MAX_ALLOWED_SCALE;
    }
    isCurrentFullScreen = isMobileLandscape || isFullscreenScale;
    const isFullStateChanged = isPrevFullscreen !== isCurrentFullScreen;
    if (isFullStateChanged && (isOrientationChanged || isScaleChanged)) {
        updateRatioForAllDisplayedForms(isCurrentFullScreen);
    }
}

function listenToResize() {
    var target = window.visualViewport || window;
    target.addEventListener('resize', handleFullscreenStateChange);
}

function updateRatioForDisplayedForm(shownFormId, isFullscreen) {
    var deviceType = KAMPYLE_DATA.getMemoryData('kampyleDevice');
    var formData =  KAMPYLE_DATA.getFormData(shownFormId);
    if (!canUsePartialView(shownFormId, formData.formType, deviceType)) {
        return;
    }
    var messageData = { action: 'mobileFullscreenChanged', data: { isFullscreen : isFullscreen  } };
    KAMPYLE_UTILS.sendMessageToIframe(KAMPYLE_DATA.getFormIframeId(shownFormId), messageData);
    reactToHeightRatioChange('scaleResize', { formId: shownFormId });
}

function reactToHeightRatioChange(eventName, eventData) {
    var formId = eventData.formId;
    var deviceType = KAMPYLE_DATA.getMemoryData('kampyleDevice');
    var formData =  KAMPYLE_DATA.getFormData(formId);

    if (!canUsePartialView(formId, formData.formType, deviceType)) {
        return;
    }

    var formIframe = getFormIframe(formId);
    if (!formIframe) {
        return;
    }
    var isInitialSetup = eventName === 'neb_beforeFormShown';
    var formState = KAMPYLE_DATA.getFormState(formId);
    var partialViewRatio = formState && formState.ratio;
    var shouldApplyFullScreenStyle = isFullscreenScale || !partialViewRatio || partialViewRatio === 1 || isMobileLandscape;
    shouldApplyFullScreenStyle ? handleFullscreenMode(formIframe, eventData, isInitialSetup)
        : handlePartialViewMode(formIframe, eventData, partialViewRatio, isInitialSetup);
}

function restoreContainerPartialViewStyles(eventName, eventData) {
    document.removeEventListener('focusin', closePartialViewOnHostInput, true);
    var containerEl = document.getElementById('kampyleFormContainer');
    if (containerEl != null) {
        KAMPYLE_UTILS.setElementStyle(containerEl, {
            'background-color': KAMPYLE_CONSTANT.COLORS.BACKDROP,
            'pointer-events': 'unset'
        }, true);
    }
}

function animateIn(formIframe, position) {
    requestAnimationFrame(function () {
        var positionStyle = {};
        positionStyle[position] = '0';
        KAMPYLE_UTILS.setElementStyle(formIframe, positionStyle, true);
    });
}

function animateOut(eventName, eventData) {
    var formData =  KAMPYLE_DATA.getFormData(eventData.formId);
    var position = formData.inviteData && formData.inviteData.invitationPosition || 'bottom';
    var positionStyle = {};
    positionStyle[position] = '0';
    KAMPYLE_UTILS.setElementStyle(getFormIframe(eventData.formId), positionStyle);
}

function handleFullscreenMode(formIframe, eventData, isInitialSetup) {
    if (!isInitialSetup) {
        restoreContainerPartialViewStyles('handleFullscreenMode', eventData);
        KAMPYLE_VIEW.prepareHostingDOM();
    }
    applyFullscreenStyles(formIframe);
}

function handlePartialViewMode(formIframe, eventData, partialViewRatio, isInitialSetup) {
    setPartialViewStyles(formIframe, eventData.formId, partialViewRatio, isInitialSetup);
    allowInteractionWithHost();
    KAMPYLE_VIEW.hideButton('handlePartialViewMode', eventData);
}

function getHeightStyle(newHeight) {
    return {
        'height': newHeight,
        'max-height': newHeight,
        'min-height': newHeight,
    };
}

function applyFullscreenStyles(formIframe) {
    var iframeStyle = getHeightStyle('100%');
    if (isFullscreenScale) {
        iframeStyle.borderRadius = '0';
    }
    KAMPYLE_UTILS.setElementStyle(formIframe, iframeStyle, true);
}

function getFormIframe(formId) {
    return document.getElementById(KAMPYLE_DATA.getFormIframeId(formId));
}

function canUsePartialView(formId, triggerType, deviceType) {
    return !KAMPYLE_DATA.isPopupDisplayType(formId)
        && deviceType !== KAMPYLE_CONSTANT.DEVICES.DESKTOP
        && partialViewSupportedTriggers.includes(triggerType);
}

function closePartialViewOnHostInput(e) {
    if (isCurrentFullScreen) return;
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
        var shownFormsState = KAMPYLE_DATA.getAllShownForms();
        for (var formId in shownFormsState) {
            if (shownFormsState[formId].ratio && shownFormsState[formId].ratio < 1) {
                KAMPYLE_EVENT_DISPATCHER.trigger('neb_formClosed', { formId: formId });
            }
        }
    }
}

export default {
    updateRatioForDisplayedForm: updateRatioForDisplayedForm,
    reactToHeightRatioChange: reactToHeightRatioChange,
    restoreContainerPartialViewStyles: restoreContainerPartialViewStyles,
    handleFullscreenStateChange: handleFullscreenStateChange,
    init: init
}